import React from 'react';

import classes from './LinkButton.module.scss';

// TODO: Should use DS Link button instead
const LinkButton = ({ onClick, label }) => (
  <button type="button" className={classes.linkButton} onClick={onClick}>
    {' '}
    {label}
  </button>
);

export default LinkButton;
